import React from 'react';
import { Hero } from '../components/Hero';
import { WhyUs } from '../components/WhyUs';
import { Services } from '../components/Services';
import { HowItWorks } from '../components/HowItWorks';
import { FAQ } from '../components/FAQ';
import { Reviews } from '../components/Reviews';
import { CtaBanner } from '../components/CtaBanner';
export function Home() {
  return <main data-id="element-2208">
      <div className="dark" data-id="element-2209">
        <Hero data-id="element-2210" />
      </div>
      <WhyUs data-id="element-2211" />
      <Services data-id="element-2212" />
      <HowItWorks data-id="element-2213" />
      <FAQ data-id="element-2214" />
      <Reviews data-id="element-2215" />
      <CtaBanner data-id="element-2216" />
    </main>;
}